import { Nullable } from 'global';

export enum DealSheetRulesFilterType {
  CREATE_DATE_RANGE = 'CREATE_DATE_RANGE',
  CUSTOMER_TYPE = 'CUSTOMER_TYPE',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  EQUIPMENT_TYPE = 'EQUIPMENT_TYPE',
}

export type DealSheetRulesTableRow = {
  id: string;
  name: string;
  description: Nullable<string>;

  propCustomerType: string | null;
  propCustomerPaymentType: string | null;
  propLocationZip: string | null;
  propLocationCity: string | null;
  propLocationState: string | null;
  propLocationCounty: string | null;
  propLocationCountry: string | null;
  propEquipmentType: string | null;

  createdDateTime: string;
};
